import { Pipe, PipeTransform } from '@angular/core';
import { TRESPONSE_TNA_BOARD_LISTING } from '@monorepo/types';
import { getStripColorPatternMap } from '../model/timeline.utils';

@Pipe({
  name: 'stripcolor',
})
export class StripColorPipe implements PipeTransform {
  transform(value: TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap']['COMPLETED_ON_TIME']['stripColor']) {
    console.log('Pipe Strip', value);
    return getStripColorPatternMap(value).color;
  }
}
